module.exports = __webpack_public_path__ + "img/SES_Slimliner_I_Profiles.ac9cffa2.jpg";